<template>
  <scroll-center-dialog v-model="opened" :loading="save_loading" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <v-text-field
        v-model="visitorFio"
        label="ФИО посетителя"
        disabled
        outlined
        class="mt-4 mb-n2"
    ></v-text-field>
    <v-row no-gutters class="text-left mb-n2">
      <v-col cols="12" class="text--secondary">Ограничения прохода:</v-col>
    </v-row>
    <v-radio-group
        v-model="visitor.is_in_blacklist"

        :error="hasError('is_in_blacklist')"
        :error-messages="getError('is_in_blacklist')"
    >
      <v-radio
          label="Без ограничений"
          color="grey"
          :value="false"
      ></v-radio>
      <v-radio
          label="Серый список"
          color="yellow"
          :value="null"
      ></v-radio>
      <v-radio
          label="Черный список"
          color="red"
          :value="true"
      ></v-radio>
    </v-radio-group>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";

export default {
  name: "VisitorsEditDialog",
  props: {
    opened: Boolean,
    visitorData: Object
  },
  mixins: [FormErrorsMixin],
  components: {
    ScrollCenterDialog
  },
  data() {
    return {
      save_loading: false,
      visitor_default: {
        last_name: "",
        first_name: "",
        middle_name: "",
        organization: "",
        is_foreigner: false,
        is_in_blacklist: false
      },
      visitor: undefined
    }
  },
  computed: {
    visitorFio () {
      return this.visitor.last_name + " " + this.visitor.first_name + " " + this.visitor.middle_name
    },
    form_title () {
      return "Редактировать посетителя"
    }
  },
  methods: {
    ...mapActions({
      changeVisitors: "entitled/changeVisitors"
    }),
    close(){
      this.$emit("close", false)
    },
    loadVisitorsData(){
      if(this.visitorData === undefined){
        this.visitor = this.visitor_default
      }
      else{
        this.visitor = JSON.parse(JSON.stringify(this.visitorData))
      }
    },
    save(){
      this.save_loading = true
      this.changeVisitors({
        id: this.visitor.id,
        data: {status: this.visitor.is_in_blacklist},
        finalizer: (val) => {
          this.$emit("close", this.visitor)
          this.save_loading = false
        },
        catcher:(val) => {
          this.mapErrors(val)
          this.save_loading = false
        }
      })
    }
  },
  created() {
    this.loadVisitorsData()
  }
}
</script>

<style scoped>

</style>
